import Icon from 'components/Icon';
import Seo from 'components/Seo';

export default function PrivacyPage() {
  return (
    <>
    <Seo title="Privacy Policy" description="How Devlayar handles your data and files. Most tools run in your browser." path="/privacy" />
    <div className="static-page">
      <div className="container">
        <div className="static-hero">
          <div className="static-hero-icon"><Icon name="lock" size={26} /></div>
          <h1>Privacy Policy</h1>
          <p>Last updated: 2026</p>
        </div>

        <div className="static-body">
          <p>At Devlayar, your privacy matters to us. This Privacy Policy explains what information we handle and how. By using Devlayar, you agree to the practices described here.</p>

          <h2>Your Files</h2>
          <p>Most of our tools run entirely in your browser. This means the files and text you use with these tools are processed on your own device and are never uploaded to our servers. For any tool that requires server-side processing, files are used only to perform the requested task and are not stored permanently — they are removed automatically after processing.</p>

          <h2>Information We Collect</h2>
          <p>We do not require you to create an account or provide personal information to use our tools. We may collect basic, non-personal usage data (such as which tools are popular and general traffic statistics) to help us improve the website.</p>

          <h2>Cookies and Analytics</h2>
          <p>We may use cookies and analytics services to understand how visitors use the site. These help us improve the experience. You can disable cookies in your browser settings at any time.</p>

          <h2>Advertising</h2>
          <p>We may display advertisements to keep Devlayar free. Third-party advertising partners (such as Google AdSense) may use cookies to show relevant ads based on your visits to this and other websites. You can learn more about how Google uses data and how to opt out by visiting Google's Ads Settings and policies pages.</p>

          <h2>Third-Party Links</h2>
          <p>Our website may contain links to other websites. We are not responsible for the privacy practices of those sites. We encourage you to read their privacy policies.</p>

          <h2>Children's Privacy</h2>
          <p>Devlayar is not directed at children under 13, and we do not knowingly collect personal information from them.</p>

          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date.</p>

          <h2>Contact</h2>
          <p>If you have any questions about this Privacy Policy, please reach out via our <a href="/contact">Contact page</a> or email support@devlayar.com.</p>
        </div>
      </div>
    </div>
  </>
  );
}
